import sidecodes from './data/sidecodes';

export class LicensePlate {
  private readonly licensePlate: string;

  constructor(licensePlate: string) {
    this.licensePlate = licensePlate.replace(/-/g, '').toUpperCase();
  }

  public valid(): boolean {
    return this.sidecode() !== 0;
  }

  public sidecode(): number {
    return sidecodes.findIndex((sidecode: RegExp) => this.licensePlate.match(sidecode)) + 1;
  }

  private getSidecodePattern(): RegExp {
    return sidecodes[this.sidecode() - 1];
  }

  private convertPlate(sidecode: RegExp): string {
    const matches = this.licensePlate.match(sidecode) ?? [];
    matches.shift();

    return matches.join('-');
  }

  public pretty(): string {
    const pattern = this.getSidecodePattern();
    return this.convertPlate(pattern);
  }
}
